<template>
	<li class="border-left head p-2 list-inline">
    <div
      :class="{'font-weight-bold': tieneHijos}"
      @click="mostrarHijos">
      <p class="xitem m-0"><span v-if="tieneHijos">[{{ verHijos ? '-' : '+' }}]</span> {{ item.padre.descripcion }}</p>
    </div>
    <ul v-show="verHijos" v-if="tieneHijos">
      <ManteCartaCategoriaArbol
        class="item"
        v-for="(hijos, index) in item.hijos"
        :key="index"
        :item="hijos"
        @ver-detalle="$emit('ver-detalle', $event)"
        @set-activo="$emit('set-activo', $event)"
      ></ManteCartaCategoriaArbol>
    </ul>
  </li>
</template>
<script>
	export default {
    name: 'ManteCartaCategoriaArbol',
    props: {
      item: Object
    },
    data: () => ({
      verHijos: false
    }),
    methods: {
      mostrarHijos (e) {
				this.$emit('ver-detalle', this.item);
        this.$emit('set-activo',e);

        if (this.tieneHijos) {
            this.verHijos = !this.verHijos;
        }
      }
    },
    computed: {
      tieneHijos() {
        return this.item && this.item.hijos;
      }
    },
    watch: {
			verHijos (valor) {
				if (!valor) {
					this.$emit('ver-detalle', null);
          let items = document.getElementsByClassName('xitem');
          for (var i = items.length - 1; i >= 0; i--) {
            items[i].classList.remove('bg-primary');
            items[i].classList.remove('text-white');
          }
				}
			}
    }
  }
</script>

<style>
.item {
	font-family: Menlo, Consolas, monospace;
  color: #444;
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
.head:hover {
	background-color: #f8f9fa !important;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>